import { Box } from '@mui/material';
import { FlatOption } from 'pages/AuditLogs/types';
import { textWithEllipsisStyle } from 'utilities';

const GroupHeaderContent = ({ option, onClick }: { option: FlatOption; onClick: () => void }) => (
  <Box
    title={option.label}
    onClick={onClick}
    sx={theme => ({
      fontWeight: 600,
      padding: '8px 16px',
      cursor: 'pointer',
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[300],
      '&:hover': {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[400],
      },
    })}>
    <Box
      component="span"
      sx={{
        ...textWithEllipsisStyle,
        display: 'block',
        width: '100%',
      }}>
      {option.label}
    </Box>
  </Box>
);

export default GroupHeaderContent;
